import { vistaLandFillData } from "constants-lib/seo/vistaLandFillData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getVistaLandFill = () => {
  const data = vistaLandFillData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addvistaLandFillJSONLD = () => {
  if (
    window.location.href.includes(`/us/en/eco-vista-landfill/faq`) &&
    document.getElementById(`vistaLandFillJSONLD`) === null
  ) {
    const script = vistaLandFillJSONLD()
    addJSONLDToHead(script, `vistaLandFillJSONLD`)
  } else {
    removeElement(`vistaLandFillJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const vistaLandFillJSONLD = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getVistaLandFill(),
  }
  return FaqBagsterTemplate
}
